<template>
  <div>
    <LoadingAnimation full-page v-if="loading"/>
    <TemplateModal ref="modal" center width="650" :sendFunction="onSendReport" :key="key">
      <template v-slot:activator>
        <v-btn
          @click="openModal"
          :width="size"
          :height="size"
          :elevation="0" fab
        >
          <IconsButton
            icon="button-send"
            :width="iconSize || $vuetify.breakpoint.smAndDown ? 25 : 32"
            :height="iconSize || $vuetify.breakpoint.smAndDown ? 25 : 32"
            class="mt-1 mr-1"
          />
        </v-btn>
      </template>
      <div class="send">
        <BaseInput
          :label="localStorage.translations.pages.common.text.receiver"
          v-model="work_client_people_id"
          type="autocomplete"
          :rules="['required']"
          :items="workClientPersonAllClient"
          :item-text="(i) => i.email + ' ' + i.first_name + ' ' + i.last_name"
        >
          <template v-slot:append-outer>
            <WorkClientPersonModal :create="true" :minimalize="true" :client-id="work_client_id"/>
          </template>
        </BaseInput>
        <div class="languages_grid">
          <div
            class="languages_item"
            :class="{ active: client_language_id === lang.id }"
            v-for="(lang, key) in languages"
            :key="key"
            @click="client_language_id = lang.id"
          >
            <img :src="lang.image.svg" alt=""/>
            <span>{{ key }}</span>
            <div class="languages_item__indicator"></div>
          </div>
        </div>
      </div>
      <template v-slot:submit>
        <BaseButton
          :text="
            !loading
              ? localStorage.translations.pages.common.buttons.send
              : Math.trunc(loadingProgress) + '%'
          "
          default_icon="button-send"
          type="submit"
          :active="loading"
          :round="loading"
          :loading="loading"
        />
      </template>
    </TemplateModal>
  </div>
</template>

<script>
import TemplateModal from 'components/templates/TemplateModal'
import {mapActions, mapGetters} from 'vuex'
import BaseButton from '../../base/BaseButton'
import IconsButton from "../../icons/button/IconsButton";
import LoadingAnimation from "../../LoadingAnimation";
import WorkClientPersonModal from "../../workClient/person/WorkClientPersonModal";

export default {
  name: 'StatisticProjectReportsSignSendModal',
  props: {
    edit: Boolean,
    project: [Object, Array],
    person: [Object, Array],
    textTheme: String,
    fileSend: [File, Blob, String],
    functionGeneratePdf: Function,
    info: String,
    report_id: [String, Number],
    work_client_id: [String, Number],
    function_dataList: Function,
    round: Boolean,
    size: {
      type: [Number, String, Function],
    },
    prefnc: {},
    billId: [Number, String],
    works: {
      type: Object,
      default: () => {
        return {
          work_types: [],
          extras: []
        }
      }
    },
    iconSize: [Number, String],
    notes: Boolean,
  },
  components: {
    WorkClientPersonModal,
    LoadingAnimation,
    IconsButton,
    BaseButton,
    TemplateModal,
  },
  data: () => ({
    ask: false,
    key: 0,
    loading: false,
    loadingProgress: 0,
    dialog: false,
    fileUrl: null,
    work_client_people_id: null,
    receiver_email: [],
    sender_email: null,
    subject: 'Tarjous_21097_NCC Suomi Oy_ As Oy Turun Harppuunan Kompassi',
    message:
      'Hei!\n\nKiitämme tarjouspyynnöstä. Liitteenä on tarjous muurausurakasta.\n\nToivoimme, että tarjouksemme vastaa odotuksianne ja johtaa yhteistyöhön kanssanne.',
    info_text:
      'Ystävällisin terveisin\nIrina Byyeva\nSB Rakennus Oy\nPäivärinteenpolku 4 E, 04600 Mäntsälä\n+358 40 350 19 97',
    
    list: [],
    item: '',
    error: false,
    rule: false,
    client_language_id: null,
  }),
  created() {
    if (this.person) {
      this.receiver_email.push(this.person.email)
    }
    
    this.info_text = this.info
    this.key++
  },
  watch: {
    '$refs.modal.dialog'() {
      if (this.$refs.modal && this.$refs.modal.dialog) {
        this.$forceUpdate()
        this.onWorkClientPersonAllClient(this.work_client_id)
        this.client_language_id = this.localStorage.translations.language_id
      }
    },
  },
  computed: {
    ...mapGetters('user', ['userData']),
    ...mapGetters(['apiDomain', 'inputRules']),
    ...mapGetters('workClientPerson', ['workClientPersonAllClient']),
    ...mapGetters('languages', ['languages']),
    ...mapGetters('workClientProjectsClientReports', ['workClientProjectsClientReportsGeneralNote']),
  },
  
  mounted() {
  },
  methods: {
    ...mapActions('workClient', ['onWorkClientSendOffer']),
    ...mapActions('workClientPerson', ['onWorkClientPersonAllClient']),
    ...mapActions('workClientProjectsPeriodReport', [
      'onWorkClientProjectsPeriodReportSend',
      'onWorkClientProjectsPeriodReportShow',
    ]),
    ...mapActions('workClientProjectsClientReports', [
      'onWorkClientProjectsClientReportsBillCreate',
      'onWorkClientProjectsClientReportsBillSend'
    ]),
    async checkReport() {
      await this.onWorkClientProjectsPeriodReportShow(this.report_id).then((res) => {
        if (res.data.additional_data) {
          this.openModal()
        } else {
          this.ask = true
        }
      })
    },
    openModal() {
      this.$refs.modal.openModal()
      this.sender_email = this.userData.email
      this.subject = this.textTheme
    },
    async submitFile() {
      let formData = new FormData()
      formData.append('file', this.fileSend, this.textTheme)
      await this.$store
        .dispatch('uploadFile', {
          data: formData,
        })
        .then((response) => {
          this.fileUrl = response.data.url
        })
        .catch()
    },
    async onSendReport() {
      if (this.$refs.modal.validate()) {
        this.loading = true
        if (this.prefnc) {
          this.prefnc()
        }
        if (this.billId) {
          await this.sendBill(this.billId)
        }
        else {
          let data = {
            period_report_id: this.$route.params.report_id,
            employee_reports: Object.assign([], this.works.work_types),
            work_extras: Object.assign([], this.works.extras),
            report_with_employee_notes: this.notes ? 1 : 0,
            general_note: this?.workClientProjectsClientReportsGeneralNote[this.$route.params.report_id]?.reportGeneralNote || '',
          }
          await this.onWorkClientProjectsClientReportsBillCreate({data})
            .then(res => {
              this.sendBill(res.data.data.id)
            })
            .catch(() => {
              this.loading = false
              this.$store.dispatch(
                'popup/onMessage',
                {message: this.localStorage.translations.pages.common.notifications['oshibka'], IsError: true},
                {root: true}
              )
            })
        }
      }
    },
    async sendBill(id) {
      let data = {
        work_client_people_id: this.work_client_people_id,
        client_language_id: this.client_language_id,
        report_with_employee_notes: this.notes ? 1 : 0
      }
      await this.onWorkClientProjectsClientReportsBillSend({
        id: id,
        data: data
      })
        .then(() => {
          if (this.function_dataList) {
            this.function_dataList()
          }
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.localStorage.translations.pages.common.notifications['sent_successfully'], IsError: false},
            {root: true}
          )
          this.loading = false
          this.$refs.modal.closeModal()
          this.$router.push({name: 'timeControlShowReports'})
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch(
            'popup/onMessage',
            {message: this.localStorage.translations.pages.common.notifications['oshibka'], IsError: true},
            {root: true}
          )
        })
    },
    pushPage() {
      this.$router.push({
        name: 'linkProjectReportSign',
        params: {report_id: this.report_id},
      })
    },
    addEmailSpace() {
      if (this.$refs.email_form.validate()) {
        if (Number(this.receiver_email.indexOf(this.item.slice(0, -1))) < 0) {
          this.receiver_email.push(this.item.slice(0, -1))
        }
        this.item = ''
        this.rule = false
      } else this.error = true
    },
    inputEmail() {
      this.error = false
      this.rule = true
    },
    addEmailClick() {
      if (this.item.length > 0) {
        if (this.$refs.email_form.validate()) {
          if (Number(this.receiver_email.indexOf(this.item)) < 0) {
            this.receiver_email.push(this.item)
          }
          this.item = ''
          this.rule = false
        } else this.error = true
      } else {
        this.error = true
        this.rule = true
        this.$refs.qq.focus()
      }
    },
    delEmail(id) {
      this.receiver_email.splice(id, 1)
      this.$refs.qq.focus()
    },
    editEmail(id) {
      this.item = this.receiver_email[id]
      this.receiver_email.splice(id, 1)
      this.rule = true
    },
  },
}
</script>

<style lang="scss" scoped>
.send {
  width: 100%;
  display: grid;
  row-gap: 20px;
  
  .languages_grid {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }
  
  .languages_item {
    display: grid;
    grid-template-columns: 50px auto max-content;
    align-items: center;
    cursor: pointer;
    gap: 5px;
    padding: 10px;
    
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #bedbeb;
      object-fit: cover;
    }
    
    span {
      text-transform: uppercase;
    }
    
    &__indicator {
      width: 16px;
      height: 16px;
      border: 1px solid #16558f;
      border-radius: 50%;
      position: relative;
      
      &::before {
        content: '';
        transition: 0.3s;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 62%;
        height: 62%;
        border-radius: 50%;
        background: #16558f;
        opacity: 0;
      }
    }
    
    &.active {
      .languages_item__indicator {
        &::before {
          opacity: 1;
        }
      }
      
      box-shadow: 0px 0px 16px rgba(67, 142, 184, 0.4);
    }
    
    &:hover {
      box-shadow: 0px 0px 16px rgba(67, 142, 184, 0.4);
    }
  }
}

.check_modal {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 30px 30px rgba(39, 127, 175, 0.2);
  text-align: start;
  padding: 50px 40px;
  position: relative;
  display: grid;
  row-gap: 40px;
}
</style>
